// extracted by mini-css-extract-plugin
module.exports = {"balloon":"_02712f2b3b--balloon--zcuMS","content":"_02712f2b3b--content--oSzvt","icon":"_02712f2b3b--icon--OMveG"};